"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../constants");
function splitIdsFromBetOddId(betOddIdPath) {
    var _a = betOddIdPath.split(constants_1.idPathDivider), _b = _a[0], betId = _b === void 0 ? '' : _b, _c = _a[1], matchId = _c === void 0 ? '' : _c, _d = _a[2], marketId = _d === void 0 ? '' : _d, _e = _a[3], oddId = _e === void 0 ? '' : _e;
    if (!matchId || !marketId || !oddId || !betId) {
        console.warn('bad betOddId', betId);
    }
    return {
        oddId: oddId,
        matchId: matchId,
        marketId: marketId,
        betId: betId,
    };
}
exports.default = splitIdsFromBetOddId;
//# sourceMappingURL=splitIdsFromBetOddId.js.map